export default __webpack_public_path__ + "static/media/AbMAint.6afd4143.jpg";